import { makeAutoObservable, runInAction } from 'mobx'
import { keyBy, orderBy } from '@dt/fe-utils/dist/lodash'
import McApi from 'api/memberCard.api'

class MemberCard {
  constructor () {
    makeAutoObservable(this, {}, { autoBind: true })
  }
  cardList: any[] = []
  allCardList: any[] = []
  brandLevelCardList: any[] = []
  brandLevelOneCardIds: number[] = []
  brandLevelCardMap: any = null
  bestDiscountCard: any = null
  cardIdMap: any = null

  async initData () {
    this.cardList = []
    this.allCardList = []
    this.bestDiscountCard = null
  }

  async getCardList () {
    let res: any
    try {
      res = await McApi.getCardList()
    } catch (error) { }
    runInAction(() => {
      res && (this.allCardList = res)
      res && (this.cardIdMap = keyBy(res, 'cardId'))
      res && (this.cardList = res.filter((item: any) => item.status === 'enable' && item.publishType !== 'inside'))
      if (res) {
        let memberDiscountList = []
        let memberPriceList = []
        let noDiscountList = []
        this.cardList.forEach((card: any) => {
          if (card.discountType === 'discountRate') {
            memberDiscountList.push(card)
          } else if (card.discountType === 'memberPrice') {
            memberPriceList.push(card)
          } else {
            noDiscountList.push(card)
          }
        })
        memberDiscountList = orderBy(memberDiscountList, ['discountValue', 'addTime'], ['asc', 'asc'])
        memberPriceList = orderBy(memberPriceList, ['addTime'], ['asc'])
        noDiscountList = orderBy(noDiscountList, ['addTime'], ['asc'])
        /**
         * 最优会员卡取值规则：（针对的都是餐品优惠）
         *  1.会员折扣最大，相同取创建时间最早
         *  2.会员价，取创建时间最早
         *  3.无权益，取创建时间最早
         */
        this.bestDiscountCard = [...memberDiscountList, ...memberPriceList, ...noDiscountList][0]
      }
    })
    return res ? res.filter((item: any) => item.status === 'enable' && item.publishType !== 'inside') : []
  }

  async getLevelCardList () {
    let res: any
    try {
      res = await McApi.getBrandLevelCardList()
    } catch (error) { }
    runInAction(() => {
      res && (this.brandLevelCardList = res)
      if (res) {
        const parentCardMap = {}
        const brandLevelCardMap = {}
        res?.forEach(card => {
          if (card.parentId) {
            if (!parentCardMap[card.parentId]) {
              parentCardMap[card.parentId] = []
            }
            parentCardMap[card.parentId].push({
              cardId: card.cardId,
              cardName: card.cardName,
              levelGrowth: card.levelGrowth
            })
          }
        })
        Object.keys(parentCardMap)?.forEach((parentId: any) => {
          if (parentId && !this.brandLevelOneCardIds.includes(parentId)) {
            this.brandLevelOneCardIds.push(Number(parentId))
          }
          parentCardMap[parentId]?.sort((a: any, b: any) => a.levelGrowth - b.levelGrowth)?.forEach((levelCard, index) => {
            brandLevelCardMap[levelCard.cardId] = {
              ...levelCard,
              parentId: Number(parentId),
              level: index + 2
            }
          })
        })
        this.brandLevelCardMap = brandLevelCardMap
      }
    })
    return res
  }
}

export default new MemberCard()
